import { render } from "./3DImages.vue?vue&type=template&id=072858a6"
import script from "./3DImages.vue?vue&type=script&lang=js"
export * from "./3DImages.vue?vue&type=script&lang=js"

import "./3DImages.vue?vue&type=style&index=0&id=072858a6&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__